export default function MySQL_VERSION() {
  return (
    <div>
      <h2>MySQL_VERSION</h2>    </div>
  );
}